import { Component, inject, Input, OnInit } from '@angular/core';
import { PaginatorModule } from 'primeng/paginator';
import { PremiumDisplayComponent } from '@shared/components/premium-display/premium-display.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { DataBaseComponent } from '@shared/directives/data-base.component';
import { FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { BvsCharterKautionsversicherungFormModel } from '../../models/forms/bvs-charter-kautionsversicherung-form.model';
import { AnswerOption, QuestionBoxComponent } from '@shared/components/question-box/question-box.component';
import { startWith, takeUntil } from 'rxjs';
import { NgClass } from '@angular/common';
import { countryAnswerOptions } from '@shared/models/country-registered-answer-options';
import { defaultAnswerOptions } from '@shared/models/default-answer-options';
import { environment } from '@environment/environment';
import { InputNumber } from 'primeng/inputnumber';
import { BoatType, CallidusCharterVersicherungspraemieCalcDto, VersicherungspraemieCalculationResultDto } from '@backend/models';
import { CharterkautionStateService } from '@shared/services/charterkaution-state.service';
import { isFormGroupInvalidExcept } from '@shared/utils/form.util';

@Component({
  selector: 'app-charter-kautionsversicherung',
  imports: [
    PaginatorModule,
    PremiumDisplayComponent,
    TranslocoPipe,
    ReactiveFormsModule,
    QuestionBoxComponent,
    NgClass,
    InputNumber
  ],
  templateUrl: './charter-kautionsversicherung.component.html',
  styleUrl: './charter-kautionsversicherung.component.scss'
})
export class CharterKautionsversicherungComponent extends DataBaseComponent implements OnInit {
  @Input() form!: FormGroup<BvsCharterKautionsversicherungFormModel>;
  
  private readonly charterkautionStateService = inject(CharterkautionStateService);

  calculationResult: VersicherungspraemieCalculationResultDto | null = null;

  showCalculationPremiumEnabled = environment.featureToggles.showCalculationPremiumEnabled;
  protected readonly countryAnswerOptions = countryAnswerOptions;
  protected readonly defaultAnswerOptions = defaultAnswerOptions;

  boatTypeAnswerOptions: AnswerOption<BoatType>[] = [
    { title: 'bvs.motoryachtMotorboot', id: BoatType.MotorbootMotoryacht, value: BoatType.MotorbootMotoryacht },
    { title: 'bvs.segelyachtSegelboot', id: BoatType.SegelbootSegelyacht, value: BoatType.SegelbootSegelyacht }
  ];

  ngOnInit(): void {
    this.form.controls.isCharterFolgeschadenVersicherungSelected.valueChanges
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(value => {
        if (value) {
          this.setYachtlengthValidator();
        } else {
          this.removeYachtlengthValidator();
        }
      });

    this.form.valueChanges
      .pipe(
        startWith(this.form.value),
        takeUntil(this.componentDestroyed$)
      )
      .subscribe(() => this.calculate());
  }

  calculate(): void {
    if (!this.isFormValidForPremiumCalculation()) return;

    const controls = this.form.controls;

    const commander: CallidusCharterVersicherungspraemieCalcDto = {
      boatType: controls.boatType.value,
      kautionsBetragInEur: controls.kautionsBetragInEur.value,
      yachtLengthInFeet: controls.yachtLengthInFeet.value
    } as CallidusCharterVersicherungspraemieCalcDto;

    this.charterkautionStateService.calculateCharterPraemie(commander)
      .subscribe((result) => {
        this.calculationResult = result;
      });
  }

  isFormValidForPremiumCalculation(): boolean {
    return !isFormGroupInvalidExcept(this.form, ['customerData']);
  }

  private setYachtlengthValidator(): void {
    this.form.controls.yachtLengthInFeet.addValidators([
      Validators.required,
      Validators.max(63)
    ]);

  }

  private removeYachtlengthValidator(): void {
    this.form.controls.yachtLengthInFeet.removeValidators([
      Validators.required,
      Validators.max(63)
    ]);
    this.form.controls.yachtLengthInFeet.updateValueAndValidity();
  }
}
